import styled from 'styled-components';

export const PhoneWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 70vw;
  margin: 0 auto;
`;

export const PhoneLabel = styled.label`
  font-size: 2.5vh;
  font-stretch: semi-expanded;
  margin-bottom: 1.5vh;
  color: rgb(0, 118, 136);
  font-weight: 500;
  :disabled {
	background-color: white;
    cursor: not-allowed;
  }
`;

export const PhoneInputWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid rgb(0, 118, 136);
  border-radius: .5vh;
  overflow: hidden;
  background-color: white;
`;

export const PhoneCountryCode = styled.div`
  background-color: white;
  color: grey;
  padding: 0 1vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5vh;
  font-weight: 200;
  height: 7vh;
  border-right: 1.5px solid rgb(0, 118, 136);
`;

export const PhoneInput = styled.input`
  flex: 1;
  border: none;
  padding: 1vh 3vw;
  font-size: 2.5vh;
  font-weight: lighter;
  font-stretch: semi-expanded;
  color: grey;
  height: 5vh;
  &:focus {
    outline: none;
  }
`;

export const PhoneFlag = styled.div`
  width: 4vh;
  height: 3.5vh;
  background: url('https://upload.wikimedia.org/wikipedia/en/c/c3/Flag_of_France.svg') no-repeat center center;	
  background-size: 125%;
  border-radius: 50%;
  margin-right: 2vw;
  background-color: #f0f0f0;
`;
